import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const ErrorFilled: React.FC<IIconProps> = ({
  size = IconSizes.md,
  color = 'black',
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <g id="Live area">
        <path
          id="Subtract"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM17.8246 19.8949L18.2124 5.63636H13.7876L14.1854 19.8949H17.8246ZM14.3146 25.5625C14.7853 26.0265 15.3487 26.2585 16.005 26.2585C16.4292 26.2585 16.8203 26.1525 17.1783 25.9403C17.5362 25.7216 17.8246 25.4332 18.0433 25.0753C18.2687 24.7107 18.3847 24.3097 18.3913 23.8722C18.3847 23.2225 18.1428 22.6657 17.6655 22.2017C17.1882 21.7377 16.6347 21.5057 16.005 21.5057C15.3487 21.5057 14.7853 21.7377 14.3146 22.2017C13.844 22.6657 13.612 23.2225 13.6186 23.8722C13.612 24.5284 13.844 25.0919 14.3146 25.5625Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default ErrorFilled;
